module.exports = __webpack_public_path__ + "static/share.12f39c64.png";